module.exports = __webpack_public_path__ + "static/img/t7.0bdd3755.png";